/* แปลงอินเตอร์zh_cn */

module.exports = {
  // นำทางหลัก
  mainNav: {
    nIndex: 'หน้าแรก',
    nVipCenter: 'ศูนย์กลางสมาชิก',
    nRecharge: 'แลกเปลี่ยนเติมเงิน'
  },
  // เกี่ยวข้องกับผู้ใช้สมัครล็อกอินและลืมรหัสผ่าน
  userOperate: {
    emailHolder: 'กรุณายืนยันอีเมล',
    pswHolder: 'กรุณาระบุรหัสผ่าน',
    codeHolder: 'กรุณาระบุรหัสยืนยัน',
    checkpassHolder: 'กรุณาระบุรหัสยืนยันอีกครั้ง',
    identHolder: 'โปรดป้อนหมายเลขประจำตัวประชาชนของคุณ',
    identTitle: 'หมายเลขบัตรประชาชน',
    loginText: 'ล็อกอิน',
    forgetText: 'ลืมรหัสผ่าน',
    registerText: 'สมัคร',
    loginTips: 'บัญชีแพลทฟอร์มช่องทางที่3 กรุณาเข้าไปทำการผูกมัดในเกมก่อน',
    loginSuccess: 'ล็อกอินสำเร็จ',
    emptyEmail: 'บัญชีอีเมลเว้นว่างไม่ได้',
    emptyPsw: 'รหัสผ่านเว้นว่างไม่ได้',
    emptyCode: 'กรุณาระบุรหัสยืนยันรูป4หลัก',
    emptyCodeNum: 'กรุณาระบุรหัสยืนยันเลข4หลัก',
    validEmail: 'กรุณาระบุอีเมลที่ถูกต้อง',
    validEmailLen: 'กรุณาระบุตัวเลขหรือตัวอักษร6-40ตัว',
    validPsw: 'กรุณาระบุตัวเลขหรือตัวอักษร6-30ตัว',
    noSamePsw: 'รหัสผ่านสองครั้งไม่ตรงกัน',
    emailTitle: 'บัญชีอีเมล',
    pswTitle: 'รหัสผ่าน',
    newPswTitle: 'รหัสผ่านใหม่',
    checkpassTitle: 'ยืนยันรหัสผ่าน',
    codeTitle: 'รหัสยืนยัน',
    readAgre: 'ฉันอ่านแล้วและยอมรับ',
    agreement: '《ข้อตกลงการสมัครบัญชี》',
    goLogin: 'ไปล็อกอิน',
    hasAccount: 'มีบัญชีแล้ว',
    readAndAgree: 'กรุณาอ่านและยอมรับ《ข้อตกลงสมัครผู้ใช้》！',
    sendcodeSuccess: 'ส่งรหัสยืนยันสำเร็จ กรุณาไปตรวจสอบที่อีเมล！',
    forgetStep: {
      stepone: 'ขั้นตอนแรก：กรุณาระบุไอดีหลงถู',
      steptwo: 'ขั้นตอนสอง： ยืนยันข้อมูลความปลอดภัย',
      stepthree: 'ขั้นตอนที่สาม：รีเซ็ตรหัสผ่านล็อกอิน',
      stepfour: 'ขั้นตอนที่สี่：รีเซ็ตรหัสผ่านสำเร็จ'
    },
    nobindTips: 'ยังไม่ได้ผูกมัดอีเมล กรุณาตใช้facebookติดต่อCSเพื่อกู้รหัสผ่าน',
    sendEmail: 'ส่งรหัสยืนยัน',
    nextStep: 'ขั้นถัดไป',
    passEmail: 'ยืนยันความปลอดภัยผ่านอีเมล',
    newPassSuccess: 'การตั้งค่ารหัสผ่านใหม่ที่ประสบความสําเร็จโปรดเข้าสู่ระบบอีกครั้ง',
    loginPlatform: 'แพลทฟอร์มล็อกอิน',
    confirmText: 'ยืนยัน',
    loadingText: 'กำลังสมัคร กรุณารอซักครู่......',
    registerSuccess: 'ยินดีด้วยสมัครบัญชีสำเร็จ<br/> เพื่อความปลอดภัยในบัญชีของท่าน ขอแนะนำว่าให้รีบทำการผูกอีเมล',
    bindAndLogin: 'ผูกอีเมลและล็อกอิน',
    bindSuccess: 'ผูกอีเมลสำเร็จ',
    confirmUnbindTips: 'แก้มัดอีเมลจะทำให้ความเสี่ยงต่อบัญชีของท่านเพิ่มมากขึ้น ยืนยันแก้มัดหรือไม่?',
    unbindSuccess: 'แก้มัดอีเมลสำเร็จ',
    sendcode: 'ส่งรหัสยืนยัน',
    sending: 'กำลังส่ง',
    loadingTextDefault: 'กำลังโหลด...'
  },
  //ปุ่มที่เกี่ยวข้องกับการบังคับของผู้ใช้
  userCenter: {
    bLogin: 'ล็อกอิน',
    bRegister: 'สมัคร',
    bForget: 'ลืมรหัสผ่าน',
    confirmLogout: 'ท่านยืนยันจะออกหรือไม่?',
    cancelText: 'ยกเลิก',
    confirmText: 'ยืนยัน',
    update: 'ล็อกอินเกินเวลาแล้ว กรุณาล็อกอินใหม่อีกครั้ง！',
    errorText: 'ร้องขอผิดพลาด กรุณาลองใหม่'
  },
  //หน้าแรก
  indexPage: {
    tAllGames: 'เกมทั้งหมด',
    enterWebsite: 'เข้าเว็บไซต์หลัก'
  },
  // ศูนย์กลางสมาชิก
  vipCenterPage: {
    sideNav: {
      base: 'ข้อมูลพื้นฐาน',
      bind: 'ผูกมัดอีเมล',
      unbind: 'แก้มัดอีเมล',
      record: 'ค้นหาบันทึก',
      modify: 'แก้ไขรหัสผ่าน',
      signout: 'ออกจากล็อกอิน'
    },
    breadcrumb: {
      current: 'ตำแหน่งปัจจุบัน',
      aNavgation: 'ศูนย์กลางสมาชิก'
    },
    base: {
      myAccount: 'บัญชีของฉัน',
      myIcons: 'เหรียญของฉัน',
      bind: 'ผูกมัดอีเมล',
      noBind: 'อีเมลยังไม่ได้ผูกมัด'
    },
    bindTips: 'แจ้ง：ผูกมัดอีเมลแล้วจะสามารถดำเนินการกู้รหัสผ่านและแก้ไขรหัสผ่านได้<br/> เพื่อความปลอดภัยในบัญชีของท่านกรุณาผูกมัดอีเมลโดยไว。',
    unbindTips: 'แจ้ง: ผูกมัดอีเมลแล้วจะสามารถดำเนินการกู้รหัสผ่านได้ <br/> แก้ไขรหัสผ่าน เพื่อความปลอดภัยของบัญชีท่าน แนะนำว่าอย่าทำการแก้มัดอีเมล',
    totalFont: 'เลขหน้ารวม',
    rechargefail: 'ยังไม่ได้ชำระ',
    rechargeSuccess: 'เติมเงินสำเร็จ',
    testSuccess: 'ความสำเร็จในการทดสอบ',
    rechargeRecord: {
      noRecord: 'ท่านยังไม่มีบันทึกเติมเงินใดๆ รีบไปเติมเงินเถอะ~',
      rechargeText: 'ไปเติมเงิน',
      title: 'บันทึกเติมเงิน',
      orderId: 'เลขการซื้อขาย',
      payAmount: 'ยอดเติมเงิน',
      payState: 'สถานะเติมเงิน',
      payWay: 'วิธีเติมเงิน',
      payTime: 'เวลาเติมเงิน'
    },
    exchangeRecord: {
      noRecord: 'ท่านยังไม่มีบันทึกแลกเปลี่ยนใดๆ รีบไปแลกเปลี่ยนเถอะ~',
      exchangText: 'ไปแลก',
      title: 'บันทึกแลกเปลี่ยน',
      name: 'ชื่อเกม',
      server: 'เซิร์ฟเกม',
      exchangeAmount: 'ยอดเงินแลก',
      getAmount: 'ได้รับยอด',
      exchangeTime: 'เวลาแลก',
      rechangeTime: 'เวลาเติมเงิน'
    },
    modifySteps: {
      stepone: 'ยืนยันความปลอดภัยข้อมูล',
      steptwo: 'รีเซ็ตรหัสผ่านล็อกอิน',
      stepthree: 'รีเซ็ตรหัสผ่านสำเร็จ'
    }
  },
  // แลกเปลี่ยนเติมเงิน
  recharge: {
    chooseGame: 'โปรดเลือกเกม',
    sideNav: {
      recharge: 'เติมเงินบัญชี',
      exchange: 'แลกเข้าเกม'
    },
    breadcrumb: {
      current: 'ตำแหน่งปัจจุบัน',
      aNavgation: 'แลกเปลี่ยนเติมเงิน'
    },
    myIcons: 'เหรียญของฉัน',
    question: 'หากพบปัญหาการเติมเงินกรุณาติดต่อCS',
    method: 'วิธีเติมเงิน',
    meal: 'โปรเติมเงิน',
    rechargeBtn: 'เติมเงิน',
    exchangeBtn: 'ยืนยันแลกเปลี่ยน',
    chooseRole: 'เลือกตัวละคร',
    gameHolder: 'กรุณาเลือกเกม',
    serverHolder: 'กรุณาเลือกเซิร์ฟเวอร์',
    roleHolder: 'กรุณาเลือกชื่อเกมส์',
    noRole: 'ในเซิร์ฟเวอร์ดังกล่าวท่านยังไม่มีตัวละครใดๆ กรุณาไปแลกที่เซิร์ฟเวอร์อื่น',
    tips: 'แจ้ง',
    noClose: 'ก่อนจ่ายเงินสำเร็จกรุณาอย่าปิดหน้าต่างนี้ จ่ายเงินสำเร็จแล้วกรุณาปุ่มด้านล่างตามสถานการณ์จริง：',
    choose: 'กรุณาสำเร็จหน้าที่เปิดมาใหม่ก่อนค่อยเลือก',
    successBuy: 'ชำระเงินสำเร็จแล้ว',
    failBuy: 'ชำระเงินพบปัญหา',
    exchangeSuccess: 'แลกโปรสำเร็จ รีบไปล็อกอินตรวจสอบดูเถอะ~',
    exchangeFail: 'แลกเปลี่ยนแปลกๆล้มเหลวแล้ว ลองใหม่อีกครั้งในภายหลังมั้ย?'
  },
  modify: {
    tips: 'แก้ไขรหัสผ่านต้องผูกมัดอีเมลก่อน',
    bindText: 'ผูกมัดอีเมล'
  },
  moblie: {
    registering: 'กำลังสมัคร...',
    readFirst: 'กรุณาอ่านข้อตกลงการสมัครบัญชีก่อน',
    connectNav: 'ติดต่อCS',
    agreement: 'ข้อตกลงการสมัคร',
    unbindText: 'ยกเลิกผูกมัด',
    bindText: 'ยืนยันผูกมัด',
    unbindTips: 'การผูกมัดอีเมลจะสามารถกู้รหัสผ่านคืนได้<br/> การดำเนินการแก้ไขรหัสผ่าน เพื่อความปลอดภัยในบัญชีของท่าน แนะนำว่าไม่ควรแก้ผูกมัดอีเมล',
    bindTips:'เมื่อผูกมัดอีเมลแล้วจะสามารถทำการกู้รหัสผ่าน และดำเนินการแก้ไขรหัสผ่านได้ <br/> เพื่อความปลอดภัยของบัญชีท่านกรุณารีบทำการผูกมัดอีเมล',
    accountHolder: 'กรุณาระบุบัญชีอีเมล',
    topPullText: 'ลากลงเพื่อรีเฟรช',
    topDropText: 'ปล่อยเพื่ออัปเดต',
    topLoadingText: 'กำลังโหลด...',
    bottomPullText: 'ลากขึ้นเพื่อดาวน์โหลด',
    bottomDropText: "ปล่อยเพื่อดาวน์โหลด",
    bottomLoadingText: "กำลังดาวน์โหลด...",
    noMore: 'ไม่มีมากกว่านี้แล้ว...',
    pleaseChoose: 'กรุณาเลือกวิธีเติมเงินและโปรเติมเงิน',
    exchangeing: 'กำลังแลก...',
    forget: {
      stepone: 'ระบุบัญชีLongtu',
      steptwo: 'ยืนยันข้อมูลความปลอดภัย',
      stepthree: 'รีเซ็ตรหัสผ่านเข้าสู่ระบบ',
      stepfour: 'รีเซ็ตรหัสผ่านสำเร็จ'
    }
  },
  order: {
    title: 'ยืนยันคำสั่งซื้อ',
    account: 'บัญชีเติมเงิน',
    meal: 'โปรเติมเงิน',
    way: 'วิธีชำระเงิน',
    amount: 'ยอดชำระเงิน',
    cancelText: 'ยกเลิก',
    confirmText: 'ยืนยันชำระเงิน'
  }
}



// WEBPACK FOOTER //
// ./src/assets/i18n/th.js